import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import {
    Apps,
    Add,
    ShoppingBagOutlined,
    ApiOutlined, InstallMobile, InstallDesktop
} from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {KBName, KBNamePlural} from "../names";
import {ListItemIcon, ListItemText} from "@mui/material";
import {isMobile} from "./utils";

// MobileMenu
export function FixedBottomNavigation() {
    const navigate = useNavigate();
    const location = useLocation();
    const ref = React.useRef(null);

    // Define the paths corresponding to the navigation actions
    const paths = ['/dashboard', '/create', '/app-center', '/api/services'
        // , '/api/introduction'
    ];

    // Find the index of the current path in the paths array
    const currentPathIndex = paths.findIndex(path => location.pathname.startsWith(path));

    // Set the initial value based on the current path
    const [value, setValue] = React.useState(currentPathIndex >= 0 ? currentPathIndex : 0);

    // State and handlers for API submenu
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    React.useEffect(() => {
        ref.current.ownerDocument.body.scrollTop = 0;
    }, [value]);

    const handleChange = (event, newValue) => {
        setValue(newValue);

        navigate(paths[newValue], { replace: true });
        // if (newValue === 4) handleClick(event);
    };

    return (
        <Box sx={{ pb: 7 }} ref={ref}>
            <CssBaseline />
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1300, overflowX: 'auto' }} elevation={3}>
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={handleChange}
                    sx={{ display: 'flex', flexWrap: 'nowrap' }}
                >
                    <BottomNavigationAction label={"My " + KBNamePlural} icon={<Apps />} />
                    <BottomNavigationAction label={`Create ${KBName}`} icon={<Add />} />
                    <BottomNavigationAction label="App Center" icon={<InstallMobile />} />
                    <BottomNavigationAction label="Services" icon={<ApiOutlined />}  />

                    {/*<BottomNavigationAction label="Documentation" icon={<InfoOutlined />} onClick={() => !location?.pathname?.startsWith?.('/api') &&  navigate('/api/introduction')} />*/}
                </BottomNavigation>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >

                    {/*<MenuItem onClick={() => { navigate('/api/introduction'); handleClose(); }}>&nbsp;Introduction</MenuItem>*/}
                    <MenuItem onClick={() => { navigate('/api/cli'); handleClose(); }}>&nbsp;CLI</MenuItem>
                </Menu>
            </Paper>
        </Box>
    );
}